import TypeAhead from '@intercom/embercom-composer/components/base/type-ahead';
import intermoji from '@intercom/intermoji';
import { hasNativeEmojiSupport } from '@intercom/embercom-composer/lib/intermoji';
import Em from 'ember';
export default TypeAhead.extend({
  type: 'emoji',
  triggerCharacter: ':',
  minimumQueryLength: 2,
  emojiSize: 16,
  triggerWidth: 3,
  selectableItems: Em.computed(function () {
    let items = [];
    let size = this.get('emojiSize');
    intermoji.prettyEmoticonsIdentifierList().forEach(function (identifier) {
      let unicode = intermoji.unicodeFromIdentifier(identifier);
      let display = `${unicode} ${identifier}`;
      if (!hasNativeEmojiSupport()) {
        display = intermoji.fallbackImage(size, display);
      }
      let key = `:${identifier}`;
      items.push(Em.Object.create({
        key,
        identifier,
        unicode,
        display
      }));
    });
    return items;
  }),
  matchingItems: Em.computed('query', function () {
    let query = this.get('query');
    if (query === '') {
      return [];
    }
    let items = this.get('items');
    let matchingItems = items.find(query);
    if (matchingItems) {
      matchingItems.setEach('isHighlighted', false);
      matchingItems.get('firstObject').set('isHighlighted', true);
    }
    return matchingItems;
  }),
  init() {
    this._super(...arguments);
    this.set('sortKeys', [{
      key: 'identifier'
    }]);
  },
  insertItem(emoji) {
    let composerState = this.get('composerState');
    this.clearTypedContent();
    if (hasNativeEmojiSupport()) {
      composerState.insertCharacters(emoji.get('unicode'));
    } else {
      composerState.insertCharacters(`:${emoji.get('identifier')}:`);
    }
    composerState.insertCharacter(' ');
  }
});